module.exports = new __parcel__URL__("26-01-24-AvgGas.578bd958.png").toString();